import React from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import clsx from 'clsx';
import { AppBar, Toolbar, makeStyles, Link } from '@material-ui/core';
import { THEMES } from 'src/constantsMessage';
import getProductType from 'src/components/ProductType';

const useStyles = makeStyles(theme => ({
  root: {
    zIndex: theme.zIndex.drawer + 100,
    ...(theme.name === THEMES.LIGHT
      ? {
          boxShadow: 'none',
          backgroundColor: theme.palette.primary.main
        }
      : {}),
    ...(theme.name === THEMES.ONE_DARK
      ? {
          backgroundColor: theme.palette.background.default
        }
      : {})
  },
  root1: {
    backgroundColor: theme.palette.background.default,
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: 'none',
    border: '0.8px solid #0000001F'
  },
  toolbar1: {
    minHeight: 108,
    padding: '8px 24px 8px 24px'
  },
  toolbar: {
    minHeight: 64
  },
  name: {
    marginLeft: theme.spacing(1)
  }
}));

function TopBar(props, { className, onMobileNavOpen, ...rest }) {
  const classes = useStyles();
  const location = useLocation();

  const productType = getProductType();

  return (
    <AppBar className={clsx(classes.root, className)} {...rest}>
      <Toolbar className={classes.toolbar}>
        {location.pathname.includes('register') ||
        location.pathname.includes('contactUs') ||
        location.pathname.includes('contactSales') ? (
          <Link
            onClick={() => window.location.assign('https://www.precisa.in')}
            style={{ cursor: 'pointer' }}
          >
            <img
              alt="Logo"
              src={
                productType === 'Signzy'
                  ? '/static/signzyWhiteLogo.png'
                  : '/static/whiteHorizontallogo.png'
              }
            />
          </Link>
        ) : (
          <RouterLink to={'/'}>
            <img
              alt="Logo"
              src={
                productType === 'Signzy'
                  ? '/static/signzyWhiteLogo.png'
                  : '/static/whiteHorizontallogo.png'
              }
            />
          </RouterLink>
        )}
      </Toolbar>
    </AppBar>
  );
}

export default TopBar;
